import {InjectionKey, Ref} from 'vue';
import {PrismicDocument} from '@prismicio/types';
import {Breakpoints} from './composables/useBreakpointsHelpers';

export const PRISMIC_HEADER_DOCUMENT: InjectionKey<PrismicDocument> = Symbol('Prismic Header Document');
export const USER_LOCALE: InjectionKey<string | undefined> = Symbol('User locale');
export const MEDIA_BREAKPOINTS: InjectionKey<Ref<Breakpoints>> = Symbol('Media breakpoints for CSS');
export const RESET_SELECTED_HOST: InjectionKey<Ref<(() => void) | undefined>> = Symbol('Reset selected host');
